import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-video-basic-info',
  templateUrl: './video-basic-info.component.html',
  styleUrls: ['./video-basic-info.component.scss']
})
export class VideoBasicInfoComponent implements OnInit {

  isVideoBookMarked = false;
  bookmarkIcon = "bookmark_border";
  bookmarkText = "Bookmark Video";

  @Input()  videoItem: any;

  constructor() { }

  ngOnInit() {
  }


  ngOnChanges(){
    console.log("VideoBasicInfoComponent"+JSON.stringify(this.videoItem));
   
  }



  bookMarkVideo(){

    if(this.isVideoBookMarked == false){
      this.bookmarkIcon = "bookmark";
      this.bookmarkText = "Remove Bookmark";
      this.isVideoBookMarked = true;
    }else{
      this.bookmarkIcon = "bookmark_border";
      this.bookmarkText = "Bookmark Video";
      this.isVideoBookMarked = false;
    }
  }
}
